import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Tag } from '../../Tag/rn';
import { Text } from '../../Text/rn';
import { Title } from '../../Title/rn';
import { Image } from '../../Image/rn';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { ConfigContext } from '../../ConfigProvider/rn/context';
// import { useTracking } from '../../../hooks/useTracking';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useTracking } from '../../../hooks/rn/useTracking';
export var CaseCard = function CaseCard(_ref) {
  var _buttonGroup$buttons;
  var title = _ref.title,
    desc = _ref.desc,
    image = _ref.image,
    statusText = _ref.statusText,
    statusColor = _ref.statusColor,
    date = _ref.date,
    buttonGroup = _ref.buttons,
    onCardClick = _ref.onCardClick,
    cardAction = _ref.cardAction,
    disabled = _ref.disabled,
    trackingData = _ref.trackingData;
  var context = useContext(ConfigContext);
  var _useTracking = useTracking({
      trackingData: trackingData
    }),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter, _context$eventEmitter2;

    // 点击埋点
    trackingClick && tracker.click(trackingClick);
    onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick();
    cardAction && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, cardAction === null || cardAction === void 0 ? void 0 : cardAction.func, {
      text: '',
      action: cardAction
    }, cardAction.callback));
  };
  return /*#__PURE__*/React.createElement(View, _extends({
    style: styles.container
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: handleCardClick,
    style: {
      width: '100%'
    },
    disabled: disabled
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.info
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.infoContent
  }, /*#__PURE__*/React.createElement(Title, {
    content: title,
    maxLines: 1
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement(Text, {
    styles: styles.infoDesc,
    maxLines: 2,
    content: desc
  }))), image != null && /*#__PURE__*/React.createElement(Image, {
    styles: {
      containerStyle: {
        marginLeft: 20
      },
      imageStyle: styles.infoImage
    },
    src: image
  })), /*#__PURE__*/React.createElement(View, {
    style: styles.status
  }, /*#__PURE__*/React.createElement(Tag, {
    color: statusColor
  }, statusText), /*#__PURE__*/React.createElement(Text, {
    styles: styles.statusDate,
    content: date,
    maxLines: 1
  }))), buttonGroup !== null && buttonGroup !== void 0 && (_buttonGroup$buttons = buttonGroup.buttons) !== null && _buttonGroup$buttons !== void 0 && _buttonGroup$buttons.length ? /*#__PURE__*/React.createElement(View, {
    style: styles.divider
  }) : null, buttonGroup && /*#__PURE__*/React.createElement(ButtonGroup, buttonGroup));
};
var styles = CustomStyleSheet({
  container: {
    flex: 1 // Add your container styles here
  },

  info: {
    flexDirection: 'row',
    padding: 12,
    alignItems: 'center'
  },
  infoContent: {
    flex: 1
  },
  infoTitle: {// Add your title styles here
  },
  infoDesc: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  infoImage: {
    width: 48,
    height: 48
  },
  status: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 10,
    paddingHorizontal: 12
  },
  statusText: {// Add your status text styles here
  },
  statusDate: {
    fontSize: 10,
    color: 'rgba(0, 0, 0, 0.26)'
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.1)'
  }
});